import find from 'lodash/find';

export const findMultiplier = (skus, itemId) => {
  const stringSku = itemId.toString();
  const match = find(skus, { sku: stringSku });

  return match ? match.multiplier : 1;
};
